import React, { useState, useEffect, useContext } from "react";
import jMoment from "moment-jalaali";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress, IconButton } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import Sorting from "./Sorting";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const InProgressSearch = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const auth = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [orderTypes, setOrderTypes] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [total, setTotal] = useState();
  const [inProgress, setInProgress] = useState([]);
  const [updater, setUpdater] = useState(true);
  const [direction, setDirection] = useState({ name: "نزولی", value: "DESC" });
  const [sortBy, setSortBy] = useState({
    name: "تاریخ شروع",
    value: "startDate",
  });

  const statuses = [
    { name: "دیر شده", value: "late" },
    { name: "ارسال امروز", value: "forToday" },
    { name: "ارسال فردا", value: "forTommorow" },
    { name: "دو روز دیگر", value: "forTwoDays" },
    { name: "سه روز دیگر", value: "forThreeDays" },
    { name: "وقت دارد", value: "notLate" },
    { name: "در انتظار", value: "inQuee" },
  ];

  const sortUpdater = (name, dir) => {
    setSortBy(name);
    setDirection(dir);
  };

  //expansion of additional fields
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  //input initialization
  const [formState, inputHandler] = useForm(
    {
      patientName: {
        value: "",
        isValid: true,
      },
      doctorName: {
        value: "",
        isValid: true,
      },
      delation: {
        value: "",
        isValid: true,
      },
      boxNumber: {
        value: "",
        isValid: true,
      },
      orderType: {
        value: "",
        isValid: true,
      },
      startDate1: {
        value: "",
        isvalid: true,
      },
      startDate2: {
        value: "",
        isvalid: true,
      },
      entranceDate1: {
        value: "",
        isvalid: true,
      },
      entranceDate2: {
        value: "",
        isvalid: true,
      },
      exitDate1: {
        value: "",
        isvalid: true,
      },
      exitDate2: {
        value: "",
        isvalid: true,
      },
    },
    true
  );

  // test
  useEffect(() => {
    console.log(formState.inputs);
  }, [formState.inputs]);

  //order search handler
  async function sendRequest() {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/search-orders",
        {
          ...(formState.inputs.patientName.value && {
            patiantName: formState.inputs.patientName.value,
          }),
          ...(formState.inputs.doctorName.value.name && {
            doctorName: formState.inputs.doctorName.value.name,
          }),
          ...(formState.inputs.boxNumber.value && {
            boxNumber: formState.inputs.boxNumber.value,
          }),
          ...(formState.inputs.orderType.value.id && {
            orderTypeId: formState.inputs.orderType.value.id,
          }),
          ...(formState.inputs.delation.value.value && {
            delation: formState.inputs.delation.value.value,
          }),
          ...(formState.inputs.startDate1.value && {
            startDateStart: new Date(
              formState.inputs.startDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.startDate2.value && {
            startDateEnd: new Date(formState.inputs.startDate2.value).getTime(),
          }),
          ...(formState.inputs.entranceDate1.value && {
            lastEntryDateStart: new Date(
              formState.inputs.entranceDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.entranceDate2.value && {
            lastEntryDateEnd: new Date(
              formState.inputs.entranceDate2.value
            ).getTime(),
          }),
          ...(formState.inputs.exitDate1.value && {
            predictionDateStart: new Date(
              formState.inputs.exitDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.exitDate2.value && {
            predictionDateEnd: new Date(
              formState.inputs.exitDate2.value
            ).getTime(),
          }),
          ascending: direction.value,
          sort: sortBy.value,
          page: props.page,
          status: 0,
          rowCount: props.rowCount,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        setInProgress([]);
        response.data.data.result.map((order) => {
          setInProgress((prevState) => [
            ...prevState,
            {
              id: order.id,
              boxNumber: order.boxNumber,
              patientName: order.patiantName,
              doctorName: order.doctorLab.name,
              startDate: order.startDate,
              orderType: order.orderType.name,
              lastEntry: order.process?.startDate,
              predictionDate: order.process?.predictionDate,
              delation: order.delation,
            },
          ]);
        });
        setTotal(response.data.data.totalItem);
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
      });
  }

  //getting pageCount from total orders
  const pageCount = Math.ceil(total / props.rowCount);

  //inProgress search request
  useEffect(() => {
    sendRequest();
  }, [updater, props.page]);

  //sending the data to the parent component
  useEffect(() => {
    props.getOrderData(inProgress, pageCount);
  }, [inProgress]);

  // getting orderTypes
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-orderTypes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 0,
              rowCount: 0,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setOrderTypes(responseData.data.result);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err.data &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  //getting doctor names
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-doctors`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 1,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setDoctorNames(responseData.data.result);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err.data &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  //test
  // useEffect(() => {
  //   console.log(sortBy?.value, direction?.value);
  // }, [sortBy, direction]);

  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setUpdater(!updater);
        }}
      >
        <Grid container spacing={3}>
          <Sorting sortUpdater={sortUpdater} />
          <Grid md={2.4} xs={6}>
            <Input
              id="patientName"
              element="input"
              label="نام بیمار"
              validators={[VALIDATOR_VALIDATED()]}
              errorText="لطفا نام بیمار را وارد کنید."
              onInput={inputHandler}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={2.4} xs={6}>
            <Input
              id="doctorName"
              element="autoComplete"
              label="نام پزشک"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا نام دکتر را انتخاب کنید."
              onInput={inputHandler}
              options={doctorNames}
              getOptionLabel={(option) => option.name}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={2.4} xs={6}>
            <Input
              id="boxNumber"
              element="input"
              label="شماره جعبه"
              validators={[VALIDATOR_VALIDATED()]}
              errorText="لطفا شماره جعبه را وارد نمایید."
              onInput={inputHandler}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>

          <Grid md={2.4} xs={6}>
            <Input
              id="orderType"
              element="autoComplete"
              label="نوع کار"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا نوع کار را انتخاب کنید."
              onInput={inputHandler}
              options={orderTypes}
              getOptionLabel={(option) => option.name}
              required={true}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={2.4} xs={6}>
            <Input
              id="delation"
              element="autoComplete"
              label="وضعیت کار"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا وضعیت کار را انتخاب کنید."
              onInput={inputHandler}
              options={statuses}
              getOptionLabel={(option) => option.name}
              inputValid={true}
              required={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={12} xs={12}>
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </ExpandMore>
          </Grid>
          <Grid md={12}>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <Grid container spacing={3}>
                <Grid md={4} xs={12}>
                  <Grid md={12} sx={{ mb: 0, pb: 0 }}>
                    <Typography
                      variant="caption"
                      display="block"
                      gutterBottom
                      sx={{ mb: -1 }}
                    >
                      بازه شروع سفارش
                    </Typography>
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="startDate1"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="شروع"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="startDate2"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="پایان"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                </Grid>
                <Grid md={4} xs={12}>
                  <Grid md={12} sx={{ mb: 0, pb: 0 }}>
                    <Typography
                      variant="caption"
                      display="block"
                      gutterBottom
                      sx={{ mb: -1 }}
                    >
                      بازه آخرین ورود
                    </Typography>
                  </Grid>
                  <Grid md={12}>
                    {" "}
                    <Input
                      id="entranceDate1"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="شروع"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="entranceDate2"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="پایان"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                </Grid>
                <Grid md={4} xs={12}>
                  <Grid md={12} sx={{ mb: 0, pb: 0 }}>
                    <Typography
                      variant="caption"
                      display="block"
                      gutterBottom
                      sx={{ mb: -1 }}
                    >
                      بازه پیش بینی خروج
                    </Typography>
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="exitDate1"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="شروع"
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="exitDate2"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="پایان"
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
          <Grid xs={12} sm={12}>
            <Button
              type="submit"
              // disabled={!formState.isValid}
              fullWidth
              color="secondary"
              variant="outlined"
              size="small"
            >
              جستجو
            </Button>
          </Grid>
        </Grid>
      </form>
    </React.Fragment>
  );
};

export default InProgressSearch;
